var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { toast } from "react-hot-toast";
import { useMutation } from "react-query";
import { translateBackendErrorCode } from "@jti/fe-common";
import { CasAuthApi } from "@jti/rest-api";
import { Button, DEPRECATED_TextInput, Form, FormField, Label, Recaptchabar, TranslationHtmlWrapper, useConfig, useForm, useTranslations, validationPatterns, } from "@jti/ui";
import styles from "./ResetPasswordForm.module.scss";
const ResetPasswordForm = ({ onSuccessfulReset }) => {
    const { __ } = useTranslations();
    const config = useConfig();
    const _a = useMutation("forgotPassword", (email) => CasAuthApi.init().forgotPassword(email)), { isLoading, mutateAsync } = _a, reset = __rest(_a, ["isLoading", "mutateAsync"]);
    const error = reset.error;
    const form = useForm({
        defaultValues: {
            email: "",
        },
    });
    const email = form.watch("email");
    const handleSubmit = useCallback(() => {
        mutateAsync(email)
            .then(() => {
            onSuccessfulReset();
        })
            .catch((error) => {
            var _a;
            const errorMessage = translateBackendErrorCode(error === null || error === void 0 ? void 0 : error.error_code, error === null || error === void 0 ? void 0 : error.message);
            if (errorMessage) {
                toast.error(errorMessage);
                return;
            }
            if ((_a = error.errors) === null || _a === void 0 ? void 0 : _a.length) {
                toast.error(error.errors);
            }
        });
    }, [email, mutateAsync, onSuccessfulReset]);
    const emailErrors = useMemo(() => { var _a, _b, _c; return (((_b = (_a = error === null || error === void 0 ? void 0 : error.errors) === null || _a === void 0 ? void 0 : _a["email"]) === null || _b === void 0 ? void 0 : _b.length) ? (_c = error === null || error === void 0 ? void 0 : error.errors) === null || _c === void 0 ? void 0 : _c["email"].join(" ") : undefined); }, [error]);
    return (_jsx(Form, { form: form, onSubmit: handleSubmit, children: _jsxs("div", { className: styles.container, children: [_jsx(FormField, { name: "email", renderLabel: () => (_jsx(Label, { id: "email_control", label: __("reset_password.email.field_label"), required: true, showRequiredAsterisk: false })), render: ({ field }) => _jsx(DEPRECATED_TextInput, Object.assign({}, field, { id: "email_control", dataTestId: "resetPasswordEmail" })), validation: {
                        required: __("reset_password.email.validation.field_required"),
                        pattern: {
                            message: __("reset_password.email.validation.field_pattern"),
                            value: validationPatterns.EMAIL_PATTERN,
                        },
                    }, error: emailErrors }), _jsxs("div", { className: styles.resetBtnWrapper, children: [_jsx(Button, { className: styles.resetBtn, type: "submit", color: "primary", disabled: !email.length || isLoading, "data-testid": "resetPasswordButton", children: __("reset_password.reset_button_label") }), config.reCaptchaEnabled && config.brandingInformationEnabled && _jsx(Recaptchabar, {})] }), _jsx("p", { className: styles.helpContact, children: _jsx(TranslationHtmlWrapper, { text: "call_us_message", htmlData: [config.CONTACT_PHONE, config.CONTACT_US_URL] }) })] }) }));
};
export default memo(ResetPasswordForm);
